import { IThemeSemantics, ThemeCompiler } from '../styling/types';
import { DefaultTheme } from 'styled-components';

export function createThemeCompiler<TS extends IThemeSemantics = IThemeSemantics,
    TTheme extends DefaultTheme = DefaultTheme>(compiler: ThemeCompiler<TS, TTheme>) {
    return compiler;
}
